import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import { Link } from 'gatsby';

import ButtonEditor from '../../../EditorPanel/ButtonEditor';
import SubLinks from './SubLinks';
import Image from '../../../Image';
import styles from './styles.module.css';

class NavLink extends React.Component {

  constructor(props) {

    super(props);

    this.hoverMenuLink = this.hoverMenuLink.bind(this);

  }

  hoverMenuLink(event, target) {

    if (event.type === 'mouseenter') {

      if (event.target.closest('.NavLink') && target !== this.props.showSubPageLink) {

        this.props.onMenuLinkClick(target);

      }

    } else if (event.type === 'mouseleave') {

      if (
        (!event.relatedTarget.closest('.NavLink') && !event.target.className.includes('arrow'))
      ) {

        this.props.onMenuLinkClick(target);

      }

    }

  }

  render() {

    const positionRelative = {
      position: 'relative',
    };

    const rawLink = this.props.link;
    let link;
    const targetValue = rawLink.openLinkInNewTab ? '_blank' : '_self';

    let button;
    if (rawLink.format === 'BUTTON') {

      button = (
        <ButtonEditor
          themeData={this.props.themeData}
          button="Button"
          data={rawLink.formatData}
          text={rawLink.text || rawLink.name || rawLink.path || ''}
          buttons={this.props.buttons}
        />
      );

    }

    let style = {
      ...positionRelative,
      color: this.props.color,
    };
    if (this.props.isBurger) {

      style = { ...style, fontSize: '1.25rem' };

    }

    const linkContent = (
      <React.Fragment>
        {
          rawLink.format === 'IMAGE' && rawLink.formatData && rawLink.formatData.id
          && (
            (
              <Image
                id={rawLink.formatData.id}
                alt={`Navbar_Image_${rawLink.formatData.id}`}
                imageClass="navbarImage"
                images={this.props.images}
              />
            )
          )
        }
        { button }
        {
          rawLink.format === 'ICON' && rawLink.formatData
          && (
            <i className={`entypo ${rawLink.formatData.class}`} style={{ fontSize: rawLink.formatData.size, color: rawLink.formatData.color }} aria-hidden />
          )
        }
        {
          rawLink.format === 'TEXT'
          && (
            (rawLink.type === 'EXTERNAL' && (rawLink.text || rawLink.path))
            || rawLink.name
          )
        }
      </React.Fragment>
    );

    if (rawLink.type === 'EXTERNAL' || targetValue === '_blank') {

      let url = rawLink.path;
      if (rawLink.type === 'SECTION') url = `${rawLink.path}#${rawLink.id}`;
      link = (
        <a
          href={url}
          className={`${styles[`menu${rawLink.children && rawLink.children.length > 0 && !this.props.isBurger ? 'Main' : ''}Link`]} ${styles.Link}`}
          style={style}
          target={targetValue}
          rel="noopener noreferrer"
        >
          { linkContent }
        </a>
      );

    } else {

      link = (
        <Link
          to={rawLink.path || '/'}
          state={rawLink.type === 'SECTION' ? { scrollToSection: rawLink.id } : undefined}
          className={`${styles[`menu${rawLink.children && rawLink.children.length > 0 && !this.props.isBurger ? 'Main' : ''}Link`]} ${styles.Link}`}
          style={style}
          activeStyle={rawLink.type !== 'SECTION' ? this.props.activeStyle : undefined}
          onClick={this.props.onLinkClick}
        >
          { linkContent }
        </Link>
      );

    }

    let divider;
    if (this.props.divider && this.props.divider > 1) {

      let div;
      switch (this.props.divider) {

        case 2:
          div = <span style={{ fontSize: '2rem' }}>&bull;</span>;
          break;
        case 3:
          div = <span>&#xFF5C;</span>;
          break;
        default:
        // Nothing here

      }

      divider = (
        <div style={{ color: this.props.color, display: 'inline-block' }}>
          {div}
        </div>
      );

    }

    const element = (
      <React.Fragment>
        <div
          className={`NavLink noEvents ${styles[`menuItem${rawLink.format === 'TEXT' && rawLink.children && rawLink.children.length > 0 ? 'Sub' : ''}`]}`}
          key={`NavigationBar_${rawLink.id}`}
          onMouseEnter={!this.props.isBurger && rawLink.children && rawLink.children.length > 0
            ? e => this.hoverMenuLink(e, rawLink.id) : undefined}
          onMouseLeave={!this.props.isBurger && rawLink.children && rawLink.children.length > 0
            ? e => this.hoverMenuLink(e, rawLink.id) : undefined}
          style={rawLink.format === 'ICON' ? { marginLeft: '5px', marginRight: '5px' } : undefined}
        >
          { link }
          {
            !this.props.isBurger && rawLink.format === 'TEXT' && rawLink.children && rawLink.children.length > 0
            && (
              <div className={styles.Link} style={{ display: 'inline-flex', width: '16px', height: '16px' }}>
                <i
                  role="button"
                  tabIndex="0"
                  onKeyPress={() => this.props.onMenuLinkClick(rawLink.id)}
                  onClick={() => this.props.onMenuLinkClick(rawLink.id)}
                  style={{ color: this.props.color }}
                  className={styles.arrow}
                />
              </div>
            )
          }
          {
            (this.props.isBurger || this.props.showSubPageLink === rawLink.id)
            && rawLink.format === 'TEXT' && rawLink.children && rawLink.children.length > 0
            && (
              <SubLinks
                onLinkClick={this.props.onLinkClick}
                themeData={this.props.themeData}
                color={this.props.color}
                activeStyle={this.props.activeStyle}
                links={rawLink.children}
                isBurger={this.props.isBurger}
                subColor={this.props.subColor}
              />
            )
          }
        </div>
        { divider }
      </React.Fragment>
    );

    return element;

  }

}

NavLink.propTypes = {
  color: PropTypes.string,
  link: PropTypes.shape({}),
  onLinkClick: PropTypes.func,
  onMenuLinkClick: PropTypes.func,
  showSubPageLink: PropTypes.string,
};

export default CSSModules(NavLink, styles, { allowMultiple: true });
